module.exports = __webpack_public_path__ + "activitybanner.21ed80c2.png";